<template>
  <div class="body-of-home">
    <div class="caption">
      <h1>... benvenuti in DogMotics</h1>
    </div>
    <div class="button-box">
      <b-container>
        <b-col>
          <div class="col align-self-center button" variant="primary" size="md" @click.prevent="onClickButton" style="max-width: 44%; padding: 10px;">
            <strong><h1>ENTRA</h1></strong>
          </div>
        </b-col>
      </b-container>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
      }
    },
    methods: {
      onClickButton() {
        event.preventDefault()
        this.$router.push({ name: 'welcome' })
      }
    }
  };
</script>

<style>
.body-of-home {
  width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    position: fixed;
    background-image: url(../assets/home.jpg) !important;
    background-color:#ccc; 
    background-repeat: no-repeat;
    background-size: cover;
    background-position-x: center 
}
.title-box {
  height: 70%;
  width: 80%px;  
}
.button-box {
  height: 25%;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
.button {
    max-width: 44% important!;
    color: #fff;
    border-radius: 20px;
    background-color: #bad000;
    padding: 10px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }
  .button:hover {
    background-color: #777;
    cursor: pointer;
  }
</style>
/*<style>
  .body-of-home {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    position: fixed;
    background-image: url(../assets/home.jpg) !important;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover
  }
  .caption {
    width: 40%;
    height: 60vh;
    color: #fff;
    padding: 100;
    text-align: center;
    margin: 30px auto;
  }
  .button {
    width: 120px;
    height: 70px;
    color: #fff;
    border-radius: 20px;
    background-color: #bad000;
    padding: 10px;
    bottom: 30px;
    text-align: center;
    position: absolute;
    margin: 30px auto 30px auto;
  }
  .button:hover {
    background-color: #777;
    cursor: pointer;
  }
</style>*/